var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationorange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.85813 0 0.5 3.35813 0.5 7.5C0.5 9.13094 1.03469 10.6275 1.92344 11.8531C1.93938 11.8825 1.94187 11.9153 1.96 11.9434L6.96 19.4434C7.19188 19.7913 7.5825 20 8 20C8.4175 20 8.80812 19.7913 9.04 19.4434L14.04 11.9434C14.0584 11.9153 14.0606 11.8825 14.0766 11.8531C14.9653 10.6275 15.5 9.13094 15.5 7.5C15.5 3.35813 12.1419 0 8 0ZM8 10C6.61937 10 5.5 8.88062 5.5 7.5C5.5 6.11937 6.61937 5 8 5C9.38062 5 10.5 6.11937 10.5 7.5C10.5 8.88062 9.38062 10 8 10Z",
    fill: "#EC6325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationorange);
export default __webpack_public_path__ + "static/media/locationorange.6c4e49407f8aab801f9183902d6ee17c.svg";
export { ForwardRef as ReactComponent };